module.exports = __webpack_public_path__ + "img/1440.23a4f51f.jpg";